import React from 'react';
import './Header.css';
import Logo from './Logo';
import Nav from './Nav';

const Header = ({  }) => {


  return (
    <header className="header fixed-top" id="header">
      <div className="header-content d-flex align-items-center justify-content-between">
      
        <Logo />
        <Nav />
        
       
      </div>
    </header>
  );
}

export default Header;
